import { createReportApi } from '@/api/modules/reportFactory'

// drive 域核心场景路径与 v1/v2 不同（无 car/ 前缀）
const api = createReportApi('drivingReport/', {
    coreSceneTreePath:  'coreScene/tree',
    coreSceneVideoPath: 'coreScene/video',
})

export const getReportIndexData    = api.getReportIndexData
export const getRecommendCar       = api.getRecommendCar
export const getRankData           = api.getRankData
export const getRankNodeData       = api.getRankNodeData
export const getCarSummaryData     = api.getCarSummaryData
export const getCarScore           = api.getCarScore
export const getCarScoreInnovate   = api.getCarScoreInnovate
export const getTestDetail         = api.getTestDetail
export const getInnovateDetail     = api.getInnovateDetail
export const getInnovateLineDetail = api.getInnovateLineDetail
export const getNodeLineDetail     = api.getNodeLineDetail
export const getNodeLineTwoDetail  = api.getNodeLineTwoDetail
export const addCompareCar         = api.addCompareCar
export const delCompareCar         = api.delCompareCar
export const getCompareCarList     = api.getCompareCarList
export const changeUserCar         = api.changeUserCar
export const searchNode            = api.searchNode
export const getParentNodes        = api.getParentNodes
export const getNodeVideos         = api.getNodeVideos
export const addCollect            = api.addCollect
export const delCollect            = api.delCollect
export const getSearchModel        = api.getSearchModel
export const getSearchResoult      = api.getSearchResoult
export const getSearchCar          = api.getSearchCar
export const getSearchResoultCx    = api.getSearchResoultCx
